import { LightbulbVariantIcon } from './LightbulbVariantIcon';

/**
 * author: Michael Irigoyen
 * id 52A21A41-EC71-4807-BE6B-CF5ED8BBAD10
 * name lightbulb-variant
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-variant.svg
 * tags
 * - Home Automation 
 */
export const LightbulbEdisonIcon = LightbulbVariantIcon;
export default LightbulbEdisonIcon